import React from 'react';
import {
  CustomHeader,
  CompletedStatus,
  InProgressStatus,
  FailedStatus,
  InQueueStatus,
  CentralContainer
} from './styled';
import {
  convertISOToDateFormat,
  convertISOToLocalDateFormat
} from '../../../../../util/timezone';
import { toLower } from '../../../../../util/lodashlike';
import ActivityLogRiskIndiModel from '../activityLogRiskIndiModel';
import AlertLevels from '../../../../common/components/AlertLevels';

// FIN-12133: getActionColor(action) resolves the action's configured severity's
// level colour (action_severity -> alert_level_details), supplied by the component.
export const columns = (
  trmActions,
  preventionResourceAccess,
  getActionColor
) => {
  const result = [
    {
      title: <CustomHeader>Execution ID</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { id } = record;
        return <b>{id}</b>;
      }
    },
    {
      title: <CustomHeader>Execution Date</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { createdAt } = record;
        return <div>{convertISOToDateFormat(createdAt)}</div>;
      }
    },
    {
      title: <CustomHeader>Date Range</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { executionConfiguration } = record;
        // FIN-9270: Handle null, undefined, or invalid JSON for "Yet to Start" instances
        let executionConfigurationParsed = {};
        try {
          if (
            executionConfiguration &&
            typeof executionConfiguration === 'string'
          ) {
            executionConfigurationParsed =
              JSON.parse(executionConfiguration) || {};
          }
        } catch (e) {
          // Parsing failed, use empty object
          executionConfigurationParsed = {};
        }
        const { training, prediction } = executionConfigurationParsed;
        const { dateRange: trainingDateRange } = training || {};
        const { dateRange: predictionDateRange } = prediction || {};
        // FIN-12014 — these are DATE boundaries the user picked in their local
        // timezone (stored as the UTC equivalent of local start/end-of-day), so
        // format them back in local tz WITHOUT the global time-adjustment that
        // convertISOToDateFormat applies to server timestamps — otherwise a
        // midnight boundary slips a day and the shown range diverges from the
        // launched range.
        return (
          <>
            <div>{`Training - ${convertISOToLocalDateFormat(
              trainingDateRange?.from
            )} - ${convertISOToLocalDateFormat(trainingDateRange?.to)}`}</div>
            <div>{`Prediction - ${convertISOToLocalDateFormat(
              predictionDateRange?.from
            )} - ${convertISOToLocalDateFormat(predictionDateRange?.to)}`}</div>
          </>
        );
      }
    },
    {
      title: <CustomHeader>Status</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { status } = record;
        const lowerStatus = toLower(status);
        return (
          <>
            {lowerStatus === 'inprogress' && (
              <InProgressStatus>{status}</InProgressStatus>
            )}
            {lowerStatus === 'completed' && (
              <CompletedStatus>{status}</CompletedStatus>
            )}
            {lowerStatus === 'failed' && <FailedStatus>{status}</FailedStatus>}
            {lowerStatus === 'inqueue' && (
              <InQueueStatus>{status}</InQueueStatus>
            )}
          </>
        );
      }
    },
    {
      title: <CustomHeader>Alerts Count</CustomHeader>,
      dataIndex: 'totalAlert',
      key: 'totalAlert'
    },
    {
      title: <CustomHeader>Alerts Level</CustomHeader>,
      key: 'id',
      render: (record) => {
        if (!preventionResourceAccess) {
          const data = {
            High: record?.highAlert || 0,
            Good: record?.goodAlert || 0,
            Low: record?.lowAlert || 0
          };

          return <AlertLevels data={data} showColumnwise />;
        } else {
          // FIN-9270: Handle null/undefined levelsCount for "Yet to Start" instances
          const levelsCount = record.levelsCount || {};
          const keys = Object.keys(levelsCount);
          return (
            <>
              {keys.map((key, index) => (
                <div
                  key={key}
                  style={{
                    color: getActionColor?.(key)
                  }}>
                  {key}: {levelsCount[key]}
                </div>
              ))}
            </>
          );
        }
      }
    }
  ];

  if (!preventionResourceAccess) {
    result.push({
      title: <CustomHeader>Risk Indicators</CustomHeader>,
      key: 'riskIndicators',
      render: ({ userThresholds = [], status = '' }) => {
        if (!preventionResourceAccess) {
          return (
            <CentralContainer>
              <ActivityLogRiskIndiModel
                userThresholds={userThresholds}
                disabled={status !== 'Completed'}
              />
            </CentralContainer>
          );
        }
      }
    });
  }

  return result;
};

export default columns;
